// Порт из market: юрназвание должно начинаться с ООО / АО / ИП.
const LEGAL_NAME_PREFIX_RE = /^(ООО|АО|ИП)(?:\s|["«»]|$)/iu

export const LEGAL_NAME_FORMAT_MESSAGE =
  'Юридическое название должно начинаться с ООО, АО или ИП'

export const isValidLegalName = (value: string): boolean =>
  LEGAL_NAME_PREFIX_RE.test(value.trim())
